export const touchpointEntityTypeConfigs = {
    business: { table: "reference_business", label: "Business-parented" },
    contact: { table: "reference_contact", label: "Contact-parented" },
    placement: { table: "placement", label: "Placement-parented" },
    community: { table: "community", label: "Community-parented" },
    homeCareLead: { table: "home_care_lead", label: "HomeCareLead-parented" },
};
export const touchpointEntityTypeList = Object.entries(touchpointEntityTypeConfigs).map(([entityType, config]) => ({ entityType, ...config }));
export const touchpointSourceKinds = [
    "sentMessage",
    "smsMessage",
    "voiceCall",
    "calendarEvent",
    "task",
    "event",
];
export const touchpointKinds = ["email", "call", "text", "visit"];
export const touchpointTypes = [
    "visit",
    "call",
    "text",
    "email",
    "note",
    "event",
    "gift",
];
export const maxMyActivityRangeDays = 92;
export const maxActivitiesReportRangeYears = 2;
export const maxActivitiesReportRangeDays = maxActivitiesReportRangeYears * 366;
export const maxActivitiesReportStaffFilter = 100;
export const maxInvolvedContactIds = 100;
//# sourceMappingURL=touchpoint.js.map